export default __webpack_public_path__ + "static/coding-background-34eac4cc117ebc9bafc130af1ad4cce8.jpg";